export enum DatasetFileTypeOption {
    FILES = 'Files',
    ANNOTATIONS = 'Annotations',
}
